<template>
  <div class="root">
    <header>Privacy Policy</header>
    <div>Introduction</div>
    <p>
      Welcome to Haba Platform (hereinafter referred to as "Haba").Haba is provided and controlled by HABAGOGO LIMITED.We respect and protect the personal information and privacy of all HABA LIMITED users in accordance with the applicable privacy laws worldwide.
    </p>
    <p>
      To provide you with more accurate and personalized services as well as a
      more secure Internet environment, we have defined our principles for the
      collection/use/provision of your personal information in accordance with
      international and relevant local laws, regulations and technical
      specifications, and further elaborated your rights related to your
      personal information.
    </p>
    <p>
      This policy is closely related to your use of our products or services.
      When you download, install, start, browse, register, log in or use our
      products or services (hereinafter collectively referred to as "using our
      products and services"), we will process and protect your personal
      information in accordance with this policy.We try our best to explain to
      you the technical terms covered by this policy in a clear and concise
      manner so that you can understand them.
      <b>
        We have used bold font to distinguish the terms in this policy that are
        (possibly) significantly related to your rights and interests. Please
        read them carefully.
      </b>
    </p>
    <b>
      In particular, we would like to draw the attention of underage users
      (especially children under the age of 13) and their guardians. We have
      specified a special section on the protection of underage users (in bold).
      Please read it carefully.
    </b>
    <p>
      Please carefully read and fully understand this policy before
      using/continuing to use our products and services, and make appropriate
      choices in accordance with the guidelines set out in this policy when
      necessary.If you do not agree with the content of this policy, it may
      cause our products or services to fail to function properly, or fail to
      achieve the intended effect of our services.You should immediately stop
      accessing/using our products and services.
      <b
        >By using or continuing to use the products and services provided by us,
        you fully understand and agree to the entire content of Haba User
        Privacy Policy(including the updated version).</b
      >
    </p>
    <div>About Us</div>
    <p>
      This policy sets out the basis for our handling of any personal data
      collected from you or provided to us by you.If you have any other
      questions about how we use your personal data, please contact us at
      report@habagogo.com.
    </p>
    <div>Table of Contents</div>
    <p>
      To improve the readability and user-friendly interaction of the privacy
      policy, we present it through the table of contents. You can click the
      table of contents to jump directly to the section you are interested in.
    </p>
    <p>·1. How do we collect and use your personal information</p>
    <p>
      ·2. How do we share, transfer and publicly disclose your personal
      information
    </p>
    <p>·3. How do we store and protect your personal information</p>
    <p>·4. How do you manage your personal information</p>
    <p>·5. How do you delete your account</p>
    <p>
      ·6. Special instructions for the use of third-party products and/or
      services
    </p>
    <p>·7. How do we use cookies and other similar technologies</p>
    <p>·8. Special terms for jurisdictions</p>
    <p>·9. Protection of underage users</p>
    <p>·10. How do we update our privacy policy</p>
    <p>·11. How to contact us</p>
    <p>·12. Miscellaneous</p>
    <div>1.How do we collect and use your personal information</div>
    <p>
      We will follow the principles of what is rightful, legal and necessary to
      collect and use the personal information that you voluntarily provide in
      the process of using our services or that is generated as a result of
      using our products and/or services for the following purposes as stated in
      this policy.If we want to use your personal information for other purposes
      not specified in this policy, or use the information we have collected for
      other purposes based on a particular purpose, we will notify you in a
      reasonable manner and seek your consent again before using it.In addition,
      we will control the read frequency within a reasonable range.
    </p>
    <div>Registration and login</div>
    <p>
      1.1When you use your mobile phone number to register and log in, we will
      collect your
      <b>[mobile phone number and mobile phone operator information]</b>
      so as to provide you with quick login service.
    </p>
    <p>
      1.2 When you register Haba with a third-party account (such as
      facebook, Apple ID), you need to authorize us to read the public
      information (nickname, avatar) you registered with the third-party
      account. The third-party platform’s handling of your personal information
      will be governed by the third-party’s privacy policy.
    </p>
    <p>
      1.3You can also choose to fill in or change your information according to
      your own needs, but if you do not provide such information, it will not
      affect your use of the product and related services (except for the user
      name, which is required for registration).
    </p>
    <p>
      1.4If you have successfully registered your Haba account, we will
      display your personal information in the app.
    </p>
    <div>When you use platform services</div>
    <p>
      2.1 We will automatically collect data from you, i.e. your Open ID, IP
      address, device information code, device information series ID, Android
      ID, XID (ID generated based on existing device information, model,
      manufacturer, Android ID and time zone settings), registration time, login
      time and records about your use of the services, such as the date and
      timestamp of the operation.We also collect and store your data below:
    </p>
    <p>
      2.1.1 The data you voluntarily provide to us when setting your nickname,
      profile picture, age, gender and country in the app;
    </p>
    <p>
      2.1.2 Every time you interact with us, for example, when you chat with us
      using the in-app feedback or customer service function;
    </p>
    <p>
      2.1.3 If you use our chat services, we will process and transmit such data
      through end-to-end encryption so that your messages can be safely passed
      on to other users;Unless the user receiving your message or you are not
      online, we will not store the information generated when you use our chat
      services. After the offline message is received or the message is not
      received for more than 90 days, we will delete the temporary message;
    </p>
    <p>
      2.1.4 If you make any transaction through Google Play or iOS App Store and
      other third parties, we will collect information to facilitate your
      transaction and maintain transaction records (including Open ID and user
      information fees, currency, purchased products, purchase history, IP
      address, transaction details as well as device details, such as operating
      system version, mobile phone model or device type, and Internet
      connection);
    </p>
    <p>
      2.1.5 If you contact our support team to deal with the problem such as
      program errors, we will collect some information, including name, OpenID,
      device ID, app version, battery power, WiFi intensity, available space in
      device, network type, operating system version, browser type, platform,
      operator, country/area code, coupon details, e-mail address and any
      information you provide in the message.You can also choose to provide
      photos to illustrate any errors;
    </p>
    <p>
      2.1.6 If you need to share contentwithintheappto other apps, we will read
      your installed app list so that sharing operation can be completed. If you
      do not provide this authorization, it will not affect your use of other
      functions of our app.
    </p>
    <p>
      2.2 Safe operation.To ensure the safe operation of the software and
      services, we will collect your device model, device name, device ID
      (includingIMEI, IMSI, and Android ID), browser type and Settings, language
      Settings, operating system version, app version, network device hardware
      address, login IP address, network access method, network quality data,
      mobile network information (including operator name), and product version
      number.To protect your account from malicious use by other users, please
      understand that we will dynamically detect whether there is abnormal login
      in your account. Every time you switch or restart the app, we may read the
      information of your device ID again, and we will control the read
      frequency within a reasonable range.
    </p>
    <p>
      2.3 When you use platform services, our security and anti-cheating
      security functions will (i) analyze user device status to identify
      security risks and cheating;(ii) detect whether your username, bio,
      profile photo, or chat messagescontains malicious information.
    </p>
    <p>
      2.4 Positioning function.In some areas under administration, we may
      collect your Global Positioning System (GPS) data and mobile device
      location information with your permission.If you don't want to share your
      exact location with us, you can turn off location-based services via
      settings on your mobile device.
      <b
        >GPS location information is personal sensitive information. If you
        refuse to provide such information, you will not be able to use the
        above location-based services, but it will not affect your use of other
        functions of Haba.</b
      >
    </p>
    <p>
      2.5 Customer service and after-sales service functions.When you contact
      our customer service staff or apply for after-sales service of our
      products and/or services, for the security of your account and system, we
      may require you to provide relevant personal information to match the
      personal information you previously provided, so as to verify your user
      identity.After successful verification, we may collect the information
      when you chat with us (account information, order information, and
      picture/video/text information and relevant information provided by you to
      prove relevant facts), your contact information, and records when you chat
      with us, including the online chat records and mobile phone recording, so
      as to solve the problem for you as soon as possible and improve our
      products and/or services.At the same time, we may contact you by phone,
      text message, system message and other relevant means to solve your
      problems arising in the process of using our products and services.
    </p>
    <p>
      2.6 To ensure that you can maintain instant messaging with the background
      server when using the services of Haba and that you can receive
      personalized content push in a timely manner, we will i) obtain and invoke
      your boot broadcast permission to start the mobile client software of
      Haba or its affiliates; ii) use a third-party push messaging service to
      generate an ID for you to identify the uniqueness of your device.
    </p>
    <p>2.7 Summary of device permissioninvocation</p>
    <p>
      During the process of providing services to you at Haba, we may invoke
      some of your device permissions.You can choose to close some or all
      permissions in the device's settings.The display mode and closing mode of
      permissions may be different in different devices. For details about how
      to invoke device permissions, please refer to the
      <a href="/device_permission_invocation_list.html"
        ></a
      >
      <router-link to="/device">Device Permission Invocation List.</router-link>




    </p>
    <p>
      2.8 To fulfill our legal obligations and, where necessary, to protect the
      public interest or protect the vital interests of users and others, we may
      use your data to help us prevent and respond to abuse, fraud, illegal
      activities and other potentially harmful content.
    </p>
    <div>Exceptions to authorized consent</div>
    <p>
      In accordance with relevant laws and regulations, we may collect and use
      some necessary personal information without your authorized consent under
      the following circumstances:
    </p>
    <p>
      (1) Information related to our performance of obligations under laws and
      regulations;
    </p>
    <p>
      (2) Information directly related to national security and national defense
      security;
    </p>
    <p>
      (3) Information directly related to public security, public health and
      major public interests;
    </p>
    <p>
      (4) Information directly related to criminal investigation, prosecution,
      trial and execution of judgment and related matters;
    </p>
    <p>
      (5) Information that are hard to get your consent for the purpose of
      protecting your or other life, property and relevant major legal rights
      and interests;
    </p>
    <p>
      (6) Your personal information that are disclosed by you to the public;
    </p>
    <p>
      (7) Your personal information collected from legally and publicly
      disclosed information: from lawful news reports, government information
      disclosure and related channels;
    </p>
    <p>
      (8) Information necessary under the online agreement or contract you have
      signed with the platform;
    </p>
    <p>
      (9) Information necessary to maintain the safe and stable operation of our
      products and/or services: such information are used to detect and dispose
      of faults in the products or services and to deal with related problems;
    </p>
    <p>(10) Other circumstances as provided for by laws and regulations.</p>
    <div>
      2.How do we share, transfer and publicly disclose your personal
      information
    </div>
    <b> Sharing: </b>
    <br />
    <b>
      We will not share your personal information with any other company,
      organization or individual unless one or more of the following
      circumstances exist:
    </b>
    <br />
    <b> (1)We have obtained your consent in advance; </b>
    <br />
    <b>(2)It is proposed by yourself;</b>
    <br />
    <b>(3)Necessary sharing with business partners:</b>
    <br />
    <b>
      You understand and be informed that, in order to provide you with more
      complete and high-quality products and services, we will authorize our
      business partners to provide you with some services.In such cases, we may
      share some of your personal information with our partners, so as to
      provide you with better customer service and user experience.Please note
      that we will only share your personal information for legal, legitimate,
      necessary, specific and explicit purposes and will only share your
      personal information as is necessary to provide our services.We will
      conduct security assessment and processing on the output form, flow and
      use of information data, so as to ensure data security.At the same time,
      we will carry out strict supervision and management to our partners.Once
      we find that they are handling your personal information in violation of
      the rules, we will terminate our cooperation with them with immediate
      effect and pursue legal responsibility against them
    </b>
    <br />
    <b>Currently, our partners include the following types:</b>
    <p>
      Cloud service providers: To provide services for global users, we choose
      cloud service providers with high-quality privacy protection and data
      security protection capabilities, such as Amazon.
    </p>
    <p>
      Content audit service provider: To ensure that the content posted by users
      on the Internet information platform is safe and complies with the
      regulatory requirements of the local government, we may share the content
      information posted by you on the platform with the third-party content
      audit service providers entrusted by us;
    </p>
    <p>
      Other business partners: Those who entrust us with promotion and
      advertising.You grant us the right to share the indirect user profiles
      formed by us using your relevant information collection with partners who
      entrust us to carry out promotion and advertising, so as to help them make
      advertising or decision-making suggestions, improve the effective touch
      rate of advertising, and further understand user needs.We promise that we
      will not share any personal information that can identify you without your
      consent.
    </p>
    <p>
      Cooperative third-party SDK providers: When you use the functions provided
      by a third partyin Haba,we may access the Software Development Kit
      (SDK) provided by a third party to realize the relevant functions.We will
      restrict the SDK service providers through cooperation agreement.
      <b>
        However,third-party SDK providers may collect your personal
        information.The aforementioned service providers' collection and
        processing of information and other activities are subject to their own
        privacy terms, and do not apply to this policy.
      </b>
      To ensure the maximum security of your information, we recommend that you
      review the privacy policy of any third-party SDK service before using it.
      To protect your legitimate rights and interests, if you find that there is
      a risk in this SDK or other similar apps, we suggest that you immediately
      stop the relevant operations and contact us in time.
    </p>
    <p>
      Message push service: To provide you with message push, third-party push
      service providers may obtain your push SDK version number, necessary
      device information, mobile phone status information, geographic location
      information and network related information so as to push information you
      may be more interested in;
    </p>
    <p>
      Please refer to
      <router-link to="/information">Information Collection and Use of Third-Party SDKs</router-link>
      for details.
    </p>
    <p>
      (4)When you choose to participate in activities organized by us or our
      affiliates or third parties on the platform, you may be required to
      provide your name, gender, mailing address, contact information and bank
      account information.
      <b
        >These are personal sensitive information.If you refuse to provide them,
        it may affect your participation in related activities, but it will not
        affect your use of other functions.</b
      >
      We willonlyshare these information with our affiliates or third parties
      with your consent, so as to ensure that you receiveconsistent services in
      experienceduring the activities.
    </p>
    <p>
      (5)Necessary sharing with our affiliates: We may share your personal
      information with our affiliates.We will only share your necessary personal
      information, and such sharing is subject to the purposes stated in this
      policy.If our affiliates want to change the purpose of processing your
      personal information, we will seek your authorization and consent again;
    </p>
    <p>
      (6)You may share your personal information or other information with third
      parties (including non-specific objects) based on the Haba Platform.
      However, Haba shall not be liable for the disclosure, use and other
      related situations of information caused by your sharing behavior.
    </p>
    <div>Transfer:</div>
    <p>
      Transfer is the transfer of control over your personal information to
      another company, organization or person.We will not transfer your personal
      information to any other company, organization or person unless we obtain
      your explicit consent.However, the following circumstances are excluded:
    </p>
    <p>(1) We have obtained your consent in advance;</p>
    <p>(2) It is proposed by yourself;</p>
    <p>
      (3) If there is a merger, acquisition or bankruptcy liquidation of our
      company, it may involve the transfer of your personal information. In this
      case, we will inform you of the relevant situation and require the new
      company,organizationand personholding your personal information to
      continue to be subject to this policy.Otherwise we will require it to
      obtain your explicit consent again.
    </p>
    <p>(4) Other circumstances as provided for by laws and regulations.</p>
    <div>Public disclosure:</div>
    <b>
      Public disclosure is the act of releasing information to society or to a
      non-specific group of people.In principle, we will not voluntarily
      disclose your personal information to the public.However, the following
      circumstances are excluded:
    </b>
    <br />
    <b>
      (1)We will show necessary information (appropriate desensitization) when
      we announce the prize winnerand penalty notice;
    </b>
    <br />
    <b> (2)We have obtained your explicit consent. </b>
    <p>
      Exceptions to authorized consent of sharing, transferring and public
      disclosure of personal information
    </p>
    <p>
      In accordance with relevant laws and regulations, we may share, transfer
      or publicly disclose your personal information without your prior
      authorized consent under the following circumstances:
    </p>
    <p>
      (1) Information related to our performance of obligations under laws and
      regulations, including disclosure of your personal information to
      competent authorities as required by laws and mandatory requirements of
      judicial or administrative authorities;In such case, we will require the
      disclosure requester to present valid legal documents corresponding to its
      request, and to take security measures in accordance with laws and
      industry standards for the disclosed information;
    </p>
    <p>
      (2) Information directly related to national security and national defense
      security;
    </p>
    <p>
      (3) Information directly related to public security, public health and
      major public interests;
    </p>
    <p>
      (4) Information directly related to criminal investigation, prosecution,
      trial and execution of judgment and related matters;
    </p>
    <p>
      (5) Information that are hard to get your consent for the purpose of
      protecting your or other life, property and relevant major legal rights
      and interests;
    </p>
    <p>
      (6) Your personal information that are disclosed by you to the public;
    </p>
    <p>
      (7) Your personal information collected from legally and publicly
      disclosed information: from lawful news reports, government information
      disclosure and related channels;
    </p>
    <p>(8) Other circumstances as provided for by laws and regulations.</p>
    <p>
      Please understand that, in accordance with the current legal provisions
      and supervision requirements, we do not need to separately notify you and
      obtain your consent to share or transfer the personal information that has
      been de-identified, and to ensure that the recipient of the data cannot
      recover and re-identify the subject of personal information.
    </p>
    <div>3.How do we store and protect your personal information</div>
    <b> Storage: </b>
    <p>
      Your personal information will be processed on servers that may not be in
      your place of residence.Our support, development and other teams around
      the world have access to your information from outside of your place of
      residence.No matter where our servers are located, we will take
      appropriate measures to protect your rights in accordance with this
      privacy policy.
    </p>
    <p>
      Our serversusedfor platform services are located in:
      <b> Frankfurt, Germany. </b>
    </p>
    <p>
      If your personal information is transmitted in different countries, we
      will separately inform you of the purpose and recipient of your personal
      information via system message or email, and we will obtain your
      authorized consent.We will strictly comply with the data protection laws
      and regulations of your country and ensure that the data recipient has
      adequate data protection capabilities to protect your personal
      information.
    </p>
    <b> Storage time: </b>
    <p>
      We undertake to store your personal information at all times within a
      reasonably necessary period as required by laws.After the above period, we
      will delete your personal information or anonymize your personal
      information.(The so-called "anonymization" refers to the process in which
      the subject of personal information cannot be identified and the processed
      information cannot be recovered through the technical processing of
      personal information.The information obtained after anonymization of
      personal information does not belong to personal information.)
    </p>
    <p>
      If we cease operation, we will stop collecting your personal information
      in a timely manner, notify you of our cessation of operation in the form
      of one-by-one service or announcement, and delete or anonymize your
      personal information held by us.
    </p>
    <b> Protection: </b>
    <p>
      To ensure the security of your personal information, we will endeavor to
      take various security measures in accordance with industry standards to
      protect your personal information, so as to minimize the risk of your
      personal information being damaged, embezzled, revealed, accessed without
      authorization, disclosed and changed.We will actively establish data
      classification and grading systems, data security management standards and
      data security development standards to manage and regulate the storage and
      use of your personal information and ensure that no personal information
      unrelated to our services are collected.
    </p>
    <p>
      Your account has security protection function.Please keep your account and
      password information properly. Haba will ensure that your information
      is not lost, abused or altered by backing up to other servers, encrypting
      user passwords and other security measures.Despite the aforementioned
      security measures, please note that there is no "100% security measure" on
      the information network.In order to prevent security incidents, we have
      formulated a proper early warning mechanism and emergency response plan in
      accordance with laws and regulations.If a security incident does occur, we
      will inform you of the relevant situation in a timely manner by email,
      letter, call, push notification and other relevant methods. When it is
      difficult to inform the subject of personal information one by one, we
      will take a reasonable and effective way to release an announcement.At the
      same time, we will also take the initiative to report the handling of
      personal information security incidents in accordance with the
      requirements of regulatory authorities, and closely cooperate with the
      governmentand regulatory authorities.
    </p>
    <div>4.How do you manage your personal information</div>
    <p>
      We take very seriously and do our best to protect your rights related to
      your personal information. You may ask us to stop using part or all of
      your data and withdraw your consent.
    </p>
    <p>
      You can choose not to receive your friend's information and not to display
      your information to your friend through the blacklist function or by
      setting of a specific friend.
    </p>
    <b> Scope of changing or withdrawing authorization </b>
    <p>
      You can also change or withdraw GPS geographical location, contacts,
      camera, and album permissions via the device's operating system.We will
      collect personal information according to your settings of changing or
      withdrawing permissions.If you withdraw the authorization, we will no
      longer collect your information related to these permissions, but please
      note that this will render some or all of the functions unavailable.
      <b
        >At the same time, your decision to change or withdraw your
        authorization will not affect the processing of your personal
        information that we previously conducted based on your authorization.</b
      >
    </p>
    <b> Automatic decision-makingofinformation system </b>
    <p>
      In some service functions, we may make decisions based solely on
      non-manual automatic decision-making mechanisms such as information system
      and algorithm.If these decisions significantly affect your legitimate
      rights and interests, you have the right to ask us for an explanation, and
      we will also provide appropriate remedies to contact us for management.
    </p>
    <p>
      For security and identification reasons, you may not be able to directly
      access, correct or delete some information through the interactive
      interface of Haba;If it is necessary for you to access, modify or
      request to delete such information according to laws, please send your
      questions to our designated email according to the contact information
      provided in Article11 of this policy. We will review the problems involved
      as soon as possible and reply to you in time after verifying your user ID.
    </p>
    <b> Obtaining copy of information </b>
    <br />
    <p>
      If you need to obtain a copy of your personal information on the platform,
      you may appeal to us according to the contact information provided in
      Article 11 of this policy, and we will reply to you in time after
      verifying your user ID.Please note that we currently only support
      providing files in csv and json formats.
    </p>
    <div>5.How do you delete your account</div>
    <p>
      You can delete your accountwithinthe appbytappingSettings -Account- Linked
      Accounts-Delete Account;After the deletion of your account, your personal
      information will be removed from Haba, except the personal information
      that must be retained by us as clearly stipulated by laws (such as the
      information related to your transactions in Haba, and the data that
      should be retained as clearly stipulated by the government or laws).
    </p>
    <p>
      Please refer tothe
      <router-link to="/account">Account Deletion Policy</router-link> 
      for details.
    </p>
    <div>
      6.Special instructions for the use of third-party products and/or services
    </div>
    <p>
      Haba may include third-party products and/or services or information
      and/or services linked to third parties.Before using the third-party
      products and/or services, you need to jump to the corresponding applet or
      third-party page.Your use of such third-party services (including any
      personal information provided by you to such third party) is subject to
      the third party's

      <router-link to="/terms">Terms of Service</router-link>
      and privacy policy (but not this policy), and you need to read the terms
      carefully and decide whether to accept them at your sole discretion.Please
      protect your personal information properly and provide them to others only
      when necessary.This policy only applies to the information collected,
      stored, used, shared and disclosed by us, but does not apply to the
      services provided by any third party or the rules governing the use of
      information by any third party. The third party shall be solely
      responsible for the behavior of using your information.
    </p>
    <div>7.How do we use cookies and other similar technologies</div>
    <p>Use of cookies</p>
    <p>
      (1) If you do not refuse to accept cookies,Haba will set or access
      cookies on your relevant mobile device so that you can log in or use the
      services or functions of Haba that rely on cookies.Haba uses cookies
      to provide you with more thoughtful personalized services, including
      promotion services.
    </p>
    <p>
      (2) You have the right to choose to accept or refuse to accept cookies.You
      can refuse to accept cookies by changing your browser settings or by
      setting it on your mobile device.However, if you choose to refuse to
      accept cookies, you may not be able to use the services or functions of
      Haba that rely on cookies.
    </p>
    <p>
      (3) This policy applies to the information obtained through cookies set in
      Haba.
    </p>
    <div>8.Special terms for jurisdictions</div>
    <b> (1)Special information for California residents </b>
    <p>
      These additional disclosures are the categories of personal information
      that are collected and disclosed for commercial purposes, as required by
      theCalifornia Consumer Privacy Act.Depending on how you interact with
      Haba's products, personal information that we may have collected or
      disclosed for commercial purposes during the past twelve months falls into
      the following categories as defined by theCalifornia Consumer Privacy Act:
    </p>
    <p>
      Identifiers, such as your name, alias, address, mobile phone number, or IP
      address;
    </p>
    <p>
      Personal information described in subsection (e) of section 1798.80 of the
      California Civil Code, such as credit card number;
    </p>
    <p>
      If we conduct a user survey or analysis, then the features(such as age or
      gender) of the protected classification under California or U.S. federal
      law;
    </p>
    <p>Business information, such as purchase activities;</p>
    <p>
      Information on Internet or other electronic network activities, including
      content interaction information, such as content download, streaming and
      playback details;
    </p>
    <p>
      Biometric information, such as your voice or appearance, for example, if
      you choose to participate in a presentation of a voice or image
      recognition service;
    </p>
    <p>
      Geographic location data, such as the location of your device or computer,
      for example, if you have location services enabled to enhance your
      experience through the event app we provide;
    </p>
    <p>
      Audio, visual, electronic or other similar information, including
      information when you communicate with us by telephone or other means;
    </p>
    <p>
      Professional or employment-related information, such as business data that
      you may provide;
    </p>
    <p>Inferred data, such as information about your preferences;</p>
    <p>
      Your rights.Under theCalifornia Consumer Privacy Act, you may have the
      right to request us to provide information about the personal information
      you collect, or to access or delete your personal information.If you wish
      to perform any of the above operations, please contact us.Depending on
      your data selection, some of our services may be restricted or
      unavailable.
    </p>
    <p>
      <b>No personal information are sold.</b>
      During the past twelve months, we have not sold any personal information
      of consumers, as these terms are defined under theCalifornia Consumer
      Privacy Act.
    </p>
    <p>
      <b> No discrimination. </b>
      We do not discriminate against any consumer who exercises their rights
      under theCalifornia Consumer Privacy Act.
    </p>
    <div>(2)The United Arab Emirates</div>
    <p>
      In particular, we will comply with the requirements of the DIFC DP Law. If
      you use the platform in the United Arab Emirates ("UAE"), in addition to
      the above personal data processing requirements, we will also abide by the
      following terms:
    </p>
    <p>
      <b>
        In accordance with Article 39 of Part 6: Rights of Data Subjects of DIFC
        DP Law, you will not be discriminated against when using the platform
        services.
      </b>
    </p>
    <div>9.Protection of underage users</div>
    <p>
      <b>
        Underage users (especially children under the age of 13 (Please refer to
        the relevant part of theTerms of Servicefor the specific definition of
        underage users)) shall read the following terms carefully in the company
        of their guardians, and the guardians shall make a decision on whether
        to accept this policy after full understanding:
      </b>
    </p>
    <p>
      <b>
        (1)Users who are minors under the age of 16(especially children under
        the age of 13) shall read this Agreement and use the relevant services
        of Haba under the supervision, guidance and consent of their
        guardians.
      </b>
    </p>
    <p>
      <b
        >(2)We attach importance to the protection of personal information of
        underage users. When filling in personal information, underage users
        shall strengthen their awareness of personal protection and treat it
        with caution. Please use relevant services of Haba correctly under
        the guidance of theirguardians.</b
      >
    </p>
    <p>
      <b>
        (3)We will ensure the confidentiality and security of underage users'
        information in accordance with relevant laws and regulations and the
        terms of this policy.If we find ourselves collecting personal
        information from underage users without the prior consent of verifiable
        parents or legal guardians, we will delete therelevantdata as soon as
        possible.If you are the guardian of an underage user, when you have any
        questions about the use of our services or the user information provided
        to us by the underage user under your guardianship, please contact us in
        time according to the contact information provided in Article11 of this
        policy.
      </b>
    </p>
    <p>
      <b>
        (4) Our Commitment We are dedicated to ensuring the safety of children
        and preventing any form of sexual abuse, exploitation, or related
        harmful activities. Our application strictly adheres to all applicable
        laws, regulations, and the "Child Safety Standards" policy, placing the
        safety and well-being of children as our top priority.
      </b>
    </p>
    <p>
      <b>
        (5) All user-generated content (UGC) undergoes dual-layer moderation,
        combining manual review with advanced algorithms to detect and prevent
        any content involving sexual abuse, exploitation, or inappropriate
        behavior.
      </b>
    </p>
    <p>
      <b>
        (6) Sexualized behavior, language, or any other inappropriate actions
        involving children are strictly prohibited on our platform. Violations
        will result in immediate action, including reporting to relevant
        authorities.
      </b>
    </p>
    <p>
      <b>
        (7) We provide user-friendly reporting tools that enable all users to
        report suspicious content or behavior quickly. A dedicated team ensures
        all reports are addressed within 24 hours.
      </b>
    </p>
    <p>
      <b>
        (8) If you encounter content or behavior involving child sexual abuse or
        exploitation, please contact us immediately: Email:
        report@habagogo.com
      </b>
    </p>
    <div>10.How do we update our privacy policy</div>
    <p>
      We reserve the right to update or amend this policy from time to
      time.These updates and amendments will form part of this policy and have
      the same effect as this policy. Without your explicit consent, we will not
      diminish your rights under this policy as currently in effect.
    </p>
    <p>
      In case of any update of this policy, we will notify you through APP
      client push notification or other relevant reasonable means, so that you
      can be informed of any changes made to this policy in a timely manner.
    </p>
    <div>11.How to contact us</div>
    <p>
      If you wish to make a complaint about how we handle your personal
      information, please contact us at report@habagogo.com and we will
      endeavour to process your request as soon as possible.This does not affect
      your right to file a claim against a data protection authority.
    </p>
    <p>
      If you have any suggestions or questions about the protection of personal
      information, or you have any questions about this policy, you can contact
      us through the following ways. We will review the problems as soon as
      possible, and give a reply within 15 working days after verifying your
      user ID.For questions about this policy, please send your comments and
      requests to:Haba Technology.Address: UNIT E01, 10/F, WONG KING IND, BUILDING, 2-4 , TAI YAU STREET, SAN PO KONG, HONG KONG, E-mail:report@habagogo.com.
    </p>
    <div>12.Miscellaneous</div>
    <p>
      (1)You have the right to file a complaint with the regulatory authority in
      charge of data protection.We attach great importance to the protection of
      users' privacy. If you have any comments or suggestions about us, you can
      send them to us. We are very happy to communicate with you and address
      your concerns.
      <router-link to="/terms">Terms of Service</router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: "privacy",
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.root {
  text-align: left;
  margin: 10px;
}
header {
  padding: 10px;
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 10px;
  font-weight: 900;
}
div {
  font-size: 25px;
  font-weight: 900;
}
b {
  font-size: 20px;
  font-weight: 900;
}

p {
  font-size: 16px;
  font-weight: 500;
}
table {
  border-collapse: collapse;
}

th,
td {
  border: 1px solid black;
  padding: 8px;
  text-align: left;
}
td,
li {
  font-size: 16px;
}
a {
  color: blue;
}
</style>
